import {HighlightTypesEnum} from '../../../../../models/api/highlightBaseModel';
import {AppThunkDispatch} from '../../../../../store/appThunk';
import {createTagAction} from '../../../../../store/data/tags/saveTagActions';
import {decorateWithClientId} from '../../../../editors/commons/clientIdModel';
import {ClientRuleAction, RuleAction, RuleActionTypesEnum} from '../../../ruleActionModel';
import {ClientRuleCondition, RuleCondition} from '../../../ruleConditionModel';
import {RuleIntegration} from '../../../ruleIntegrationModel';
import {EditorStateActions} from '../../hooks/useEditorState';
import {RuleActionCardProps} from '../../ruleActionCard';

export function buildRuleActionCardsProps(
  actions: ReadonlyArray<ClientRuleAction>,
  ruleIntegration: RuleIntegration,
  onUpdateAction: EditorStateActions['onUpdateAction'],
  onValidation: EditorStateActions['onValidation'],
  onDeleteAction?: EditorStateActions['onDeleteAction'],
) {
  return actions
    .filter((action) => action.type !== RuleActionTypesEnum.SET_CONVERSATION_METADATA) // metadata actions are hidden
    .map(
      (action): RuleActionCardProps => ({
        action,
        actionDefinition: ruleIntegration.findActionDefinition(action),
        onUpdateAction: (updatedAction) => {
          onUpdateAction(
            (a) => a.clientId === action.clientId,
            (a) => ({...updatedAction, clientId: a.clientId}),
          );
        },
        onValidation,
        onDeleteAction: onDeleteAction
          ? () => onDeleteAction((a) => a.clientId === action.clientId)
          : undefined,
        shouldHideError: false,
      }),
    );
}

export function mapToClientActions(actions: ReadonlyArray<RuleAction>): ReadonlyArray<ClientRuleAction> {
  return actions.map(decorateWithClientId);
}

export function mapToClientConditions(
  conditions: ReadonlyArray<ReadonlyArray<RuleCondition>>,
): ReadonlyArray<ReadonlyArray<ClientRuleCondition>> {
  return conditions.map((orConditions) => orConditions.map(decorateWithClientId));
}

export async function createRecipeTag(
  name: string,
  emoji: string,
  namespace: string,
  dispatch: AppThunkDispatch,
) {
  return dispatch(
    createTagAction({
      name,
      namespace,
      isVisibleInAllInboxes: true,
      showInCells: true,
      highlightEmoji: emoji,
      parentTags: [],
      showInWorkspaces: false,
      teammatesToPin: [],
      highlightType: HighlightTypesEnum.EMOJI,
    }),
  );
}
